import pdf from './pdf';

export default pdf;
